import { AnimatedSection } from "@/components/shared/AnimatedSection";

export const BenefitCard = ({ number, title, description, delay = 0 }) => (
  <AnimatedSection delay={delay} data-testid={`benefit-card-${number}`} className="border-t border-cream/20 pt-6">
    <span className="font-heading text-4xl text-accent">{number}</span>
    <h3 className="font-heading text-xl font-semibold text-cream mt-3 mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-cream/70">{description}</p>
  </AnimatedSection>
);
